import { render, staticRenderFns } from "./holdSalary.vue?vue&type=template&id=45d58bb7&scoped=true"
import script from "./holdSalary.vue?vue&type=script&lang=js"
export * from "./holdSalary.vue?vue&type=script&lang=js"
import style0 from "./holdSalary.vue?vue&type=style&index=0&id=45d58bb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d58bb7",
  null
  
)

export default component.exports